import { ReducerInstance } from '@types';

type LoadingPayload = boolean | { isLoading: boolean; id: number };

export const loading = (payload: LoadingPayload, instanceName: ReducerInstance) => {
  return {
    type: `${instanceName.toUpperCase()}_LOADING`,
    payload,
  };
};

export const failure = (payload: boolean, instanceName: ReducerInstance) => {
  return {
    type: `${instanceName.toUpperCase()}_FAILURE`,
    payload,
  };
};

export const totalItems = (payload: number, instanceName: ReducerInstance) => {
  return {
    type: `SET_${instanceName.toUpperCase()}_TOTAL`,
    payload,
  };
};

export const limit = (payload: number, instanceName: ReducerInstance) => {
  return {
    type: `SET_${instanceName.toUpperCase()}_LIMIT`,
    payload,
  };
};

export const offset = (payload: number, instanceName: ReducerInstance) => {
  return {
    type: `SET_${instanceName.toUpperCase()}_OFFSET`,
    payload,
  };
};
